// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "Open" + "." + "27b82c8e889f3880ed4f" + ".bundle.js";
};